import Vue from 'vue'
import api from '../../../api/apibackend'
import {
  GET_USERS,
  GET_USER,
  CREATE_USER,
  UPDATE_USER,
  GET_STATUSES,
  UPDATE_USER_PROFILE,
  SIGN_UP_CLIENT,
  UPDATE_SUBSCRIPTIONS,
  GET_ADMIN_DELIVERY_COMPANIES,
} from './actions.type'
import {
  SET_ADMIN_DELIVERY_COMPANIES,
  SET_USERS,
  FETCH_START,
  SET_STATUSES,
  MATCH_STATUS_NAME,
  FETCH_END
} from './mutations.type'
import {
  SET_USER_AUTH,
} from '../auth/mutations.types'

const state = {
  users: [],
  adminDeliveryCompanies: [],
  isLoading: false,
  statuses: []
}

const actions = {
  async [GET_USERS]({
    commit,
    getters,
    dispatch
  }) {
    try {
      commit(FETCH_START)
      const res = await api.get('admin')
      if (getters.statuses.length === 0) {
        await dispatch(GET_STATUSES)
      }
      let users = res.data
      users.forEach(user => {
        user.statusName = getters.statuses.find(status => status.id === user.status_id).status_name
      })
      commit(SET_USERS, users)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_ADMIN_DELIVERY_COMPANIES]({ commit, dispatch, getters }) {
    try {
      commit(FETCH_START)
      const res = await api.get('admin/deliver')
      if (getters.statuses.length === 0) {
        await dispatch(GET_STATUSES)
      }
      let companies = res.data
      companies.forEach(company => {
        company.statusName = getters.statuses.find(status => status.id === company.status_id).status_name
      })
      commit(SET_ADMIN_DELIVERY_COMPANIES, companies)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_USER]({ commit }, userId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`admin/${userId}`)
      commit(FETCH_END)
      return data
    } catch (err) {
      commit(FETCH_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  
  async [CREATE_USER]({
    commit,
    dispatch
  }, userData) {
    try {
      commit(FETCH_START)
      const res = await api.post('admin', userData)
      dispatch(GET_USERS)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      const errors = err.response.data.errors
      const errorKeys = Object.getOwnPropertyNames(errors)
      errorKeys.forEach(key => {
        Vue.notify({
          group: 'loggedIn',
          type: 'error',
          text: errors[key][0]
        })
      })
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.response.data.message
      })
    }
  },
  async [UPDATE_USER]({
    commit,
    dispatch
  }, userData) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`admin/${userData.id}`, userData)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Datos actualizados exitosamente'
      })
      dispatch(GET_USERS)
      commit(FETCH_END)
    } catch (err) {
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar los datos'
      })
    }
  },
  async [GET_STATUSES]({
    commit
  }) {
    try {
      commit(FETCH_START)
      const {
        data
      } = await api.get('admin/status')
      commit(SET_STATUSES, data)
      commit(FETCH_END)
    } catch (err) {
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [UPDATE_USER_PROFILE]({
    commit,
    rootGetters
  }, userData) {
    try {
      commit(FETCH_START)

      const res = await api.patch(`admin/${userData.id}`, userData)
      const user = await api.get(`admin/${userData.id}`)
      commit(SET_USER_AUTH, user.data[0])
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Perfil actualizado exitosamente'
      })
    } catch (err) {
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [UPDATE_SUBSCRIPTIONS]({
    commit,
    dispatch
  }, subscription) {
    try {
      const res = await api.post('subscritption', subscription)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Membresia extendida exitosamente'
      })
      await dispatch(GET_USERS)
    } catch (err) {
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al extender la membresia'
      })
    }
  },
}

const mutations = {
  [SET_ADMIN_DELIVERY_COMPANIES] (state, deliveryCompanies) {
    state.adminDeliveryCompanies = deliveryCompanies
  },
  [SET_USERS](state, users) {
    state.users = users
    state.isLoading = false
  },
  [FETCH_START](state) {
    state.isLoading = true
  },
  [FETCH_END](state) {
    state.isLoading = false
  },
  [SET_STATUSES](state, statuses) {
    state.statuses = statuses
  },
  [MATCH_STATUS_NAME](state) {
    state.users.forEach(user => {
      user.statusName = state.statuses.find(status => status.id === user.status_id).status_name
    })
  }
}

const getters = {
  users: state => {
    return state.users
  },
  isLoading: state => {
    return state.isLoading
  },
  statuses: state => state.statuses,
  statusName: state => id => state.statuses.find(status => status.id === id).status_name,
  adminDeliveryCompanies: state => state.adminDeliveryCompanies ? state.adminDeliveryCompanies : [],
}

export default {
  state,
  actions,
  mutations,
  getters
}